<template>
	<div class="default-checkbox" :class="{'default-checkbox--error': error}">
		<input class="default-checkbox__input" type="checkbox" v-model="value" :id="id" :checked="checked" :disabled="disabled">
		<label v-if="label" class="default-checkbox__label" :class="{'default-checkbox__label--hidden' : showToggle, 'default-checkbox__label--desc': description }" :for="id">
			<span>
				<p :class="{'default-checkbox__label-text--test': isTest}">{{ label }} </p>
				<span class="default-checkbox__label-description" v-if="description">{{ description }}</span>
			</span>
		</label>
	</div>
</template>

<script>
export default {
	name: "InputCheckbox",
	emits: ["update:modelValue"],
	props: {
		modelValue: {
			type: [Boolean, Number],
			default: false
		},
		checked: {
			type: Boolean,
			default: false
		},
		showToggle: {
			type: Boolean,
			default: false
		},
		label: {
			type: String,
			default: ''
		},
		description: {
			type: String,
			default: ''
		},
		id: {
			type: [Number, String],
			default: 0
		},
		isTest: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		error: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		value: {
			get() {
				return this.modelValue
			},
			set(value) {
				this.$emit('update:modelValue', value)
			}
		}
	},
}
</script>
